function readRoleValue(role) {
    if (typeof role === 'string') {
        return role;
    }
    if (!role || typeof role !== 'object') {
        return '';
    }
    return role.authority || role.name || role.role || '';
}

export function normalizeRole(role) {
    const value = readRoleValue(role);
    if (typeof value !== 'string') {
        return '';
    }
    return value.trim().toUpperCase();
}

export function normalizeRoles(roles) {
    const values = roles instanceof Set
        ? Array.from(roles)
        : (Array.isArray(roles) ? roles : [roles]);

    return Array.from(new Set(
        values
            .map(normalizeRole)
            .filter(Boolean)
    ));
}

export function hasAnyRole(userRoles, requiredRoles) {
    const normalizedRequiredRoles = normalizeRoles(requiredRoles);
    if (normalizedRequiredRoles.length === 0) {
        return true;
    }
    const userRoleSet = new Set(normalizeRoles(userRoles));
    return normalizedRequiredRoles.some((role) => userRoleSet.has(role));
}
